import React, { Component } from "react";
import { Title } from "components/misc";
import { Container } from 'design-react-kit';

import { withRouter } from 'react-router-dom';
import { AdminAudioCategory } from "components/forms/admin/AdminAudioCategory";

class AssetsAudioMainForm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      idAudioCategory: parseInt(this.props.match.params.idAudioCategory) > 0 ? this.props.match.params.idAudioCategory : 0,
      title: parseInt(this.props.match.params.idAudioCategory) > 0 ? 'Gestione Categoria' : 'Nuova Categoria',
    }
  }

  //--- ---

  render() {

    return (
      <>
        <section className="my-4">
          <Container>
            <Title>{this.state.title}</Title>
            {<AdminAudioCategory idAudioCategory={this.state.idAudioCategory} />}
          </Container>
        </section>
      </>
    );
  }

}

export default withRouter(AssetsAudioMainForm);
